module.exports = __webpack_public_path__ + "img/newsdetails1.ceb21c2b.png";